<ham-modal
    [title]="title"
    [saveText]="saveLabel"
    [showCancelButton]="true"
    [cancelText]="cancelLabel"
    (save)="onSave()"
    (cancel)="onCancel()"
>
    <div class="new-group-form">
        <div class="form-group">
            <label>{{ groupNameLabel }} <span class="required">*</span></label>
            <!-- hamInput is a ControlValueAccessor; ngModel (standalone) keeps its internal display
                 state in sync — same pattern as the new-account modal. -->
            <input
                hamInput
                class="new-group-name"
                [ngModel]="groupName"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="groupName = $event"
                [placeholder]="groupNamePlaceholder"
                [class.input-error]="submitAttempted && isGroupNameEmpty"
            />
            <div class="field-error" *ngIf="submitAttempted && isGroupNameEmpty">
                {{ errGroupNameRequired }}
            </div>
        </div>

        <div class="form-group">
            <label>{{ fliLabel }} <span class="required">*</span></label>
            <!-- returnKey='id' makes the form value the picked option's `id` field. The parent fills
                 that with the FLI's internal `name` (see `reclassNewAccountFliOptions`), which is what
                 `findFliById` resolves the container from. -->
            <input
                hamSimpleDropDown
                class="new-group-fli"
                [options]="fliOptions"
                [optionKeys]="['label']"
                returnKey="id"
                [allowFreeText]="false"
                [ngModel]="fliId"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="fliId = $event ?? ''"
                [placeholder]="fliPlaceholder"
                [class.input-error]="submitAttempted && isFliEmpty"
            />
            <div class="field-error" *ngIf="submitAttempted && isFliEmpty">
                {{ errFliRequired }}
            </div>
        </div>

        <div class="field-warn" *ngIf="groupAlreadyExists">{{ hintGroupExists }}</div>
    </div>
</ham-modal>
